const $inject = [];

const duplicateBookingsService = function () {
  let service = {};

  service.set = (flag) => {
    sessionStorage.setItem('loadDuplicateBooking', flag)
  }

  service.get = () => { 
    const loadDuplicateBooking = sessionStorage.getItem('loadDuplicateBooking');
    return loadDuplicateBooking ? JSON.parse(loadDuplicateBooking) : true
  }

  return service;
};

duplicateBookingsService.$inject = $inject;

export default duplicateBookingsService;



// WEBPACK FOOTER //
// ./src/services/duplicateBookingsService.js